export const neutrals = {
  gray200: '#F4F4F4',
  gray250: '#EBEBEB',
  gray300: '#DDDDDD',
  gray500: '#ADADAD',
  gray700: '#666666',
  gray750: '#3f3f3f',
  gray800: '#323232',
  gray850: '#242424',
  gray900: '#131313',
  white: '#FFFFFF',
  transparent: 'rgba(0,0,0,0)',
};

export const blues = {
  blue100: '#F5FBFE',
  blue200: '#B8D8FA',
  blue300: '#8ABEF7',
  blue400: '#2E8BF0',
  blue500: '#0072ED',
  blue600: '#0064D1',
  blue700: '#0057B4',
  blue800: '#003B7B',
  blue900: '#002E5F',
};

export const greens = {
  green100: '#E6F7E7',
  green200: '#ACE1B3',
  green300: '#73C881',
  green400: '#39AB51',
  green500: '#008A23',
  green600: '#007919',
  green700: '#006511',
  green800: '#004E0B',
  green900: '#003405',
};

export const reds = {
  red100: '#F8EAEA',
  red200: '#EBC3C3',
  red300: '#D27575',
  red400: '#C64F4F',
  red500: '#AB2525',
  red600: '#AB2525',
  red700: '#9D2222',
  red800: '#8F1F1F',
  red900: '#741919',
};

export const yellows = {
  yellow100: '#FFFAEB',
  yellow200: '#FFF0C6',
  yellow300: '#FFDC7D',
  yellow400: '#FFD359',
  yellow500: '#FFC934',
  yellow600: '#E0B12E',
  yellow700: '#C29928',
  yellow800: '#85691B',
  yellow900: '#665015',
};

export const primary = {
  primary100: blues.blue100,
  primary500: blues.blue500,
  primary700: blues.blue700,
};

export const secondary = {
  secondary100: greens.green100,
  secondary500: greens.green500,
  secondary700: greens.green700,
};

export const error = {
  light: reds.red100,
  dark: reds.red900,
};

export const success = {
  light: greens.green100,
  dark: greens.green900,
};

export const warn = {
  light: yellows.yellow100,
  dark: yellows.yellow900,
};

export const info = {
  light: blues.blue100,
  dark: blues.blue900,
};

export const opacity = {
  opacity10: '1A',
  opacity20: '33',
  opacity30: '4D',
  opacity40: '66',
  opacity50: '80',
  opacity60: '99',
  opacity70: 'B3',
  opacity80: 'CC',
  opacity90: 'E6',
};
